import { inject, Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';

export interface WorkspaceSearchHit {
  kind: string;
  document_id: string;
  title: string;
  subtitle: string;
  route_params: Record<string, string>;
}

export interface WorkspaceSearchResponse {
  query: string;
  results: WorkspaceSearchHit[];
  truncated: boolean;
}

interface WorkspaceSearchRequest {
  workspace_id: string;
  query: string;
  limit?: number;
}

/**
 * Thin client over `callable-universal-search`. Workspace records are searched through the backend
 * index so that opening search never reads a workspace collection.
 */
@Injectable({
  providedIn: 'root',
})
export class UniversalSearchApiService {
  private functions = inject(Functions);

  public async search(workspaceId: string, query: string, limit = 20): Promise<WorkspaceSearchResponse> {
    const callable = httpsCallable<WorkspaceSearchRequest, WorkspaceSearchResponse>(this.functions, 'callable-universal-search');
    const response = await callable({ workspace_id: workspaceId, query, limit });
    return response.data;
  }
}
